module.exports = __webpack_public_path__ + "img/eq-shadow-dancer.efbc4fd7.png";